import React, { useState, useCallback } from "react";
import { Menu, Dropdown, Avatar, Button, Image } from "antd";
import { DownOutlined, UserOutlined, MenuOutlined, LockOutlined } from "@ant-design/icons";
import { LogoutOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import ProfilePopup from "./ProfileCompo";
import { useDispatch, useSelector } from "react-redux";
import { persistor } from "../../redux/store";
import { USER_LOGIN_CLEAR_STATE, USER_TOKEN } from "../../redux/types";
import { BE_HOST } from "../../config/config";
import axios from "axios";
import { store } from "../../redux/store";
import { useEffect } from "react";
import Support from "../../screen/dashboard/support/Support";
import ChangePassword from "../../screen/dashboard/changePassword/ChangePassword";
import { axiosInstance } from "../../utils/axiosInterceptor";
import newLogo from "../../assets/advant-logoTm.png";

const { SubMenu } = Menu;
const Header = ({ userAuth, initialColor }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const tokeninstate = useSelector((state) => state.userAuth.token);
  const [PasswordModal, setPasswordModal] = useState(false)

  const [popupWithScrollViewVisible, setPopupWithScrollViewVisible] =
    useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [supportVisible, setSupportVisible] = useState(false)

  const hide = useCallback(() => {
    setPopupWithScrollViewVisible(false);
  }, [setPopupWithScrollViewVisible]);

  const handleLogoClick = () => {
    navigate("/");
  };
  const userDetailsState = useSelector((state) => state.userAuth.decodedToken.user);
  // console.log(userDetailsState,'emailslsss')
  // const [userDetailsState, setUserDetailsState] = useState(null);
  // useEffect(() => {
  //   const fetchUserDetails = async () => {
  //     try {
  //       if (email?.username) {
  //         const token = localStorage.getItem("token");
  //         const response = await axios.get(
  //           `${BE_HOST}/users/user-details?email=${email?.email}`,
  //           {
  //             headers: { Authorization: token },
  //           }
  //         );
  //         console.log(response,"reponseeeeee")
  //         // Store user details in localStorage with proper data structure
  //         if (response?.data) {
  //           localStorage.setItem(
  //             "userDetails",
  //             JSON.stringify(response.data.data)
  //           );
  //         }
  //         setUserDetailsState(response.data.data);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching user details:", error);
  //     }
  //   };
  //   fetchUserDetails();
  // }, [email]);
  // console.log(userDetailsState, "userDetails");

  // const logoutUser = async () => {
  //   try {
  //     const userInfo = localStorage.getItem("userInfo");
  //     const sessionId = store.getState().userAuth.sessionId;
  //     console.log(userInfo, "tokenUSERNINFO");
  //     const token = userInfo?.data?.token ? JSON.parse(userInfo).data.token : tokeninstate ? tokeninstate?.token: null;
  //     // console.log(sessionId, "sessonId");
  //     // console.log(userInfo, "userInfo");
  //     // return;
  //     const res = await axios.get(`${BE_HOST}/auth/signout`, {
  //       headers: {
  //         Authorization: token,
  //         "Content-Type": "application/json",
  //         "X-Session-ID": sessionId,
  //       },
  //     });
  //     // const res = await axios.get(`${BE_HOST}/auth/signout`);

  //     window.location.href = res.data.logoutUri;
  //     localStorage.removeItem("userInfo"); //token
  //     persistor.purge();
  //     dispatch({
  //       type: USER_LOGIN_CLEAR_STATE,
  //     });
  //     dispatch({
  //       type: USER_TOKEN,
  //       payload: {
  //         token : '',
  //         decodedToken: '', // Parse the JSON string
  //       },
  //     })
  //   } catch (err) {
  //     console.log("error while loging out", err);
  //   }
  // };

  const logoutUser = async () => {
    try {
      const userInfo = localStorage.getItem("userInfo");
      const token = localStorage.getItem('token');
      const sessionId = store.getState().userAuth.sessionId;
      // console.log(userInfo, "tokenUSERNINFO");
      // const token = userInfo?.data?.token ? JSON.parse(userInfo).data.token : tokeninstate ? tokeninstate?.token: null;
      // console.log(sessionId, "sessonId");
      // console.log(userInfo, "userInfo");
      // return;
      // const res = await axios.get(`${BE_HOST}/auth/signout`, {
      //   headers: {
      //     Authorization: token,
      //     "Content-Type": "application/json",
      //     "X-Session-ID": sessionId,
      //   },
      // });
      const res = await axiosInstance.get(`${BE_HOST}/auth/logout`);
      console.log("res", res);


      // window.location.href = res.data.logoutUri;
      localStorage.removeItem("userInfo"); //token
      localStorage.removeItem("token"); //token

      persistor.purge();
      dispatch({
        type: USER_LOGIN_CLEAR_STATE,
      });
      dispatch({
        type: USER_TOKEN,
        payload: {
          token: '',
          decodedToken: '', // Parse the JSON string
        },
      })
    } catch (err) {
      console.log("error while loging out", err);
    }
  };


  // console.log(userDetailsState,"userDetailsState")
  const isGodUser = userDetailsState?.user_roles_id === 5;
  const isAdmin = userDetailsState?.user_roles_id === 4 || userDetailsState?.user_roles_id === 5 || userDetailsState?.user_roles_id === 7 || userDetailsState?.user_roles_id === 8 || userDetailsState?.user_roles_id === 10;

  const hasAccess = userDetailsState?.user_roles_id === 4 || userDetailsState?.user_roles_id === 5 || userDetailsState?.user_roles_id === 7 || userDetailsState?.user_roles_id === 10;
  const menu = (
    <Menu className="max-w-[250px] md:max-w-none">
      <SubMenu key="gpr" title="GPR">
        {/* <Menu.Item key="gpr-dashboard">
          <a href="/dashboard_gpr">Dashboard</a>
        </Menu.Item> */}
        <Menu.Item key="gpr-leakages">
          <a href="/data_table_gpr">Leakages</a>
        </Menu.Item>
      </SubMenu>
      <SubMenu key="gcr" title="GCR">
        {/* <Menu.Item key="gcr-dashboard">
          <a href="/react-dashboard">Dashboard</a>
        </Menu.Item> */}
        <Menu.Item key="gcr-purchases">
          <a href="/data_table_gcr">Purchases</a>
        </Menu.Item>
      </SubMenu>
       <Menu.Item key="data-dictionary">
            <a href="/data-dictionary">Data Dictionary</a>
          </Menu.Item>
          <Menu.Item key="rebate-statement">
            <a href="/rebate-statement">Rebate Statements</a>
          </Menu.Item>
      {isAdmin && (
        <>
          <Menu.Item key="users">
            <a href="/users">Users</a>
          </Menu.Item>
          <Menu.Item key="accounts">
            <a href="/accounts">Accounts</a>
          </Menu.Item>
      {/* <Menu.Item key="supplier">
            <a href="/supplier">Supplier</a>
          </Menu.Item> */}
         {hasAccess && <>
         {/* <SubMenu key="Dashboard Settings" title="Dashboard Settings">
            <Menu.Item key="/glp1-management">
          <a href="/glp1-management">GLP1 Master</a>
        </Menu.Item>
        <Menu.Item key="/session-reports">
          <a href="/session-reports">Session Reports</a>
        </Menu.Item>
        <Menu.Item key="/sftp-logs">
          <a href="/sftp-logs">SFTP history</a>
        </Menu.Item>
        <Menu.Item key="/automation-dashboard">
            <a href="/automation-dashboard">Automation Workflow</a>
          </Menu.Item>
          <SubMenu key="SMS Workflow" title="Performance Notification and Alerts">
            <Menu.Item key="/sms-config">
          <a href="/sms-config">Admin settings</a>
        </Menu.Item>
        <Menu.Item key="/sms-workflow">
          <a href="/sms-workflow">Reports</a>
        </Menu.Item>
        <Menu.Item key="email-report">
          <a href="/email-report">Email delivery Report</a>
        </Menu.Item>
      </SubMenu>
      </SubMenu> */}
          <Menu.Item key="glp1-management">
            <a href="/glp1-management">GLP1 Master</a>
          </Menu.Item>
          <Menu.Item key="session-reports">
            <a href="/session-reports">Session Reports</a>
          </Menu.Item>
          <Menu.Item key="sftp-logs">
            <a href="/sftp-logs">SFTP history</a>
          </Menu.Item>
           <Menu.Item key="/automation-dashboard">
            <a href="/automation-dashboard">Automation Workflow</a>
          </Menu.Item>
          {/* </Menu.Item> */}
          {/* <Menu.Item key="/sms-workflow">
            <a href="/sms-workflow">SMS Workflow</a>
          </Menu.Item> */}
           <SubMenu key="SMS Workflow" title="Performance Notification and Alerts">
            <Menu.Item key="/sms-config">
          <a href="/sms-config">Admin settings</a>
        </Menu.Item>
        <Menu.Item key="/sms-workflow">
          <a href="/sms-workflow">Reports</a>
        </Menu.Item>
        {
          isGodUser && (
        <Menu.Item key="email-report">
          <a href="/email-report">Email delivery Report</a>
        </Menu.Item>
          )
        }
      </SubMenu>
      {
        isGodUser && (
       <Menu.Item key="/powerbi-sales">
            <a href="/powerbi-sales">Management Dashboard</a>
          </Menu.Item>
        )
      }
      {/* <Menu.Item key="/advantage-analysis">
            <a href="/advantage-analysis">Advantage Analysis</a>
          </Menu.Item>
      <Menu.Item key="/cpt-settings">
            <a href="/cpt-settings">CPT Settings</a>
          </Menu.Item> */}
          </>}
        </>
      )}
       {/* <Menu.Item key="chat-history">
            <a href="/chat-history">Chat History</a>
          </Menu.Item> */}
    </Menu>
  );

  const userMenu = (
    <Menu className="flex flex-col" style={{ marginTop: "5px" }}>
      <Menu.Item key="user-info">
        <div className="flex gap-4 items-center">
          <Avatar
            icon={<UserOutlined />}
            className="bg-gray-100 text-blue-900 "
          // size={32} // Increased size from default
          />
          <div className="flex flex-col">
            <span className="">
              {userDetailsState?.first_name}{" "}
              {userDetailsState?.last_name}
            </span>
            <span className="text-gray-500 text-sm">
              {userDetailsState?.email}
            </span>
          </div>
        </div>
      </Menu.Item>
      <hr className="my-1 text-gray-500 -mx-1" />
      <Menu.Item
        key="profile"
        onClick={() => setPopupWithScrollViewVisible(true)}
        style={{ margin: "4px 0px" }}
      >
        <div className="flex gap-4 items-center">
          <Avatar
            icon={<UserOutlined />}
            className="bg-gray-100 text-blue-900"
          />
          <span>My Profile</span>
        </div>
      </Menu.Item>

      <Menu.Item onClick={() => setPasswordModal(true)} style={{ marginBottom: "4px" }}>
        <div className="flex gap-4 items-center">
          <Avatar
            icon={<LockOutlined />}
            className="bg-gray-100 text-blue-900"
          />
          <span>Change Password</span>
        </div>
      </Menu.Item>
      <Menu.Item onClick={logoutUser} style={{ marginBottom: "4px" }}>
        <div className="flex gap-4 items-center">
          <Avatar
            icon={<LogoutOutlined />}
            className="bg-gray-100 text-blue-900"
          />
          <span>Sign Out</span>
        </div>
      </Menu.Item>
    </Menu>
  );

  const userRoleOptions = (val) => {

    if (val == 1) {
      return 'User'
    } else if (val == 2) {
      return 'Super'
    }
    else if (val == 3) {
      return 'Admin'
    } else if (val == 4) {
      return 'System'
    }
    else if (val == 5) {
      return 'Super Admin'
    } else if (val == 6) {
      return 'Demo'
    } else if (val == 7) {
      return 'GPO Admin'
    }
    else if (val == 8) {
      return 'Pharmacy Owner'
    }
    else if (val == 9) {
      return 'Pharmacy User'
    }
    else if (val == 10) {
      return 'Wholesaler Admin'
    }
    else {
      return val
    }
  }

  return (
    <>
      <ProfilePopup
        popupWithScrollViewVisible={popupWithScrollViewVisible}
        setPopupWithScrollViewVisible={setPopupWithScrollViewVisible}
        userDetailsState={userDetailsState}
        hide={hide}
        data={userAuth}
        isAdmin = {isAdmin}
      />
      <div
        className={` ${initialColor === "#000833" ? `bg-[${initialColor}]` : `bg-white`
          } ${initialColor === "#000833" ? "text-white" : "text-black"}`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mb-15">
          <div className="flex justify-between items-center py-4">
            {initialColor === "#000833" ? (
              <div className="cursor-pointer" onClick={()=>navigate("/")}>
              <Image
                style={{ }}
                src={newLogo}
                alt="Logo"
                preview={false}
                className="mt-2"
                width={200}
                // height={25}
              />
              </div>
              //  <Link className="cursor-pointer lg:ml-[-20px]" to="/">
              //   <svg
              //     width="215"
              //     height="28"
              //     viewBox="0 0 250 36"
              //     fill="none"
              //     xmlns="http://www.w3.org/2000/svg"
              //     className="cursor-pointer"
              //     onClick={handleLogoClick}
              //   >
              //     <path
              //       d="M36.4994 18.4137L25.0086 2.00959C24.0131 0.584207 21.9116 0.584207 20.9161 2.00959L0.441661 31.2298C-0.332585 32.3357 -0.0622103 33.8471 1.04385 34.6213C2.14992 35.3954 3.66154 35.1251 4.43578 34.0192L22.9562 7.56364L32.5544 21.2768C32.6282 21.3873 32.6773 21.4488 32.6773 21.4611C32.9968 21.9157 33.1566 22.4687 33.1074 23.0708C33.0091 24.275 32.0014 25.2334 30.797 25.2949C29.8999 25.344 29.1133 24.9016 28.6586 24.2258C28.634 24.189 28.4497 23.9309 28.4497 23.9309L24.9471 18.9421C24.5047 18.3031 23.7796 17.8976 22.9439 17.8976C21.5921 17.8976 20.5106 18.9912 20.5106 20.3306C20.5106 20.8344 20.6581 21.3013 20.9284 21.6945L24.6645 27.0151C25.5247 28.2562 26.766 29.2392 28.2408 29.7676C29.0396 30.0502 29.8999 30.1977 30.797 30.1854C34.6928 30.1239 37.8267 27.0397 37.9987 23.2059C38.097 21.3996 37.5071 19.7285 36.4994 18.4137Z"
              //       fill="url(#paint0_linear_1_1666)"
              //     />
              //     <path
              //       d="M21.579 18.315C22.685 17.5531 24.2089 17.848 24.9709 18.9539C25.7329 20.0598 25.4379 21.5835 24.3318 22.3454C23.2135 23.1072 21.7019 22.8123 20.9399 21.7064C20.178 20.5882 20.4729 19.0768 21.579 18.315Z"
              //       fill="#0B9CE9"
              //     />
              //     <path
              //       d="M63.0342 26.937H65.9374L57.5496 8.47311C57.2063 7.71705 56.452 7.22961 55.6194 7.22961C54.7869 7.22961 54.0326 7.71705 53.6893 8.47489L45.3281 26.937H48.1762L50.4693 21.7175H60.7393L63.0342 26.937ZM51.4406 19.5098L55.6052 10.0315L59.7698 19.5098H51.4406Z"
              //       fill="white"
              //     />
              //     <path
              //       d="M79.2586 6.46204V14.535C78.7623 13.8945 78.1752 13.3822 77.4921 13.0015C76.4994 12.45 75.3858 12.1743 74.153 12.1743C72.7369 12.1743 71.4721 12.4874 70.3584 13.1118C69.2448 13.738 68.366 14.6061 67.7238 15.7198C67.0798 16.8334 66.7578 18.1338 66.7578 19.6246C66.7578 21.1154 67.0798 22.4211 67.7238 23.5436C68.3678 24.6662 69.2466 25.5396 70.3584 26.1658C71.4721 26.792 72.7351 27.1033 74.153 27.1033C75.4231 27.1033 76.5546 26.8223 77.5472 26.2619C78.2624 25.8581 78.8672 25.3119 79.3689 24.627V26.9379H81.9075V6.46204H79.2586ZM78.6377 22.3428C78.2054 23.1256 77.6166 23.7269 76.8712 24.1503C76.1258 24.5737 75.2933 24.7854 74.3735 24.7854C73.436 24.7854 72.5981 24.5737 71.8617 24.1503C71.1252 23.7269 70.5363 23.1256 70.0951 22.3428C69.654 21.5619 69.4334 20.6546 69.4334 19.6246C69.4334 18.5768 69.654 17.6695 70.0951 16.9063C70.5363 16.1432 71.1252 15.5508 71.8617 15.1274C72.5964 14.704 73.4343 14.4923 74.3735 14.4923C75.2933 14.4923 76.1258 14.704 76.8712 15.1274C77.6166 15.5508 78.2054 16.1432 78.6377 16.9063C79.07 17.6695 79.2871 18.5768 79.2871 19.6246C79.2853 20.6546 79.0682 21.5601 78.6377 22.3428Z"
              //       fill="white"
              //     />
              //     <path
              //       d="M113.235 12.3108V14.5327C112.739 13.8923 112.152 13.3799 111.469 12.9992C110.476 12.4477 109.362 12.172 108.13 12.172C106.713 12.172 105.449 12.4851 104.335 13.1095C103.221 13.7357 102.343 14.6038 101.7 15.7175C101.056 16.8311 100.734 18.1315 100.734 19.6223C100.734 21.1131 101.056 22.4188 101.7 23.5414C102.344 24.6639 103.223 25.5373 104.335 26.1635C105.449 26.7897 106.712 27.1011 108.13 27.1011C109.4 27.1011 110.531 26.82 111.524 26.2596C112.239 25.8558 112.844 25.3096 113.345 24.6247V26.9356H115.884V12.3108H113.235ZM112.614 22.3423C112.182 23.1251 111.593 23.7264 110.848 24.1498C110.102 24.5732 109.27 24.7848 108.35 24.7848C107.413 24.7848 106.575 24.5732 105.838 24.1498C105.102 23.7264 104.513 23.1251 104.072 22.3423C103.631 21.5614 103.41 20.6541 103.41 19.6241C103.41 18.5763 103.631 17.669 104.072 16.9058C104.513 16.1426 105.102 15.5502 105.838 15.1269C106.573 14.7035 107.411 14.4918 108.35 14.4918C109.27 14.4918 110.102 14.7035 110.848 15.1269C111.593 15.5502 112.182 16.1426 112.614 16.9058C113.047 17.669 113.264 18.5763 113.264 19.6241C113.262 20.6541 113.045 21.5596 112.614 22.3423Z"
              //       fill="white"
              //     />
              //     <path
              //       d="M97.352 12.3116L92.1521 24.1987L87.05 12.3116H84.2891L90.2237 25.8673C90.5528 26.6198 91.2964 27.1055 92.1183 27.1055C92.9402 27.1055 93.6838 26.6198 94.0129 25.8673L99.9475 12.3116H97.352Z"
              //       fill="white"
              //     />
              //     <path
              //       d="M132.654 14.9596C132.138 14.0221 131.427 13.323 130.516 12.8622C129.605 12.4033 128.552 12.172 127.357 12.172C126.031 12.172 124.873 12.4388 123.879 12.9725C123.137 13.371 122.539 13.8869 122.085 14.522V12.3108H119.547V26.9356H122.196V19.4017C122.196 18.3343 122.384 17.4431 122.761 16.7244C123.139 16.0074 123.676 15.4649 124.375 15.0966C125.074 14.7284 125.892 14.5451 126.832 14.5451C128.082 14.5451 129.054 14.9045 129.742 15.6214C130.432 16.3383 130.777 17.4057 130.777 18.8218V26.9356H133.426V18.5193C133.426 17.0855 133.168 15.8989 132.654 14.9596Z"
              //       fill="white"
              //     />
              //     <path
              //       d="M144.688 24.1767C144.136 24.6375 143.446 24.867 142.619 24.867C141.882 24.867 141.317 24.6553 140.922 24.2319C140.525 23.8085 140.328 23.2019 140.328 22.4102V14.4903H144.522V12.3111H140.328V8.38489H137.679V12.3111H135.195V14.4903H137.679V22.5205C137.679 23.9917 138.083 25.1232 138.894 25.9148C139.703 26.7064 140.844 27.1014 142.315 27.1014C142.921 27.1014 143.507 27.0178 144.067 26.8523C144.627 26.6869 145.111 26.4289 145.515 26.0802L144.688 24.1767Z"
              //       fill="white"
              //     />
              //     <path
              //       d="M150.994 24.5364V18.2994H160.68V15.9547H150.994V10.0218H161.867V7.62024H148.234V26.938H162.253V24.5364H150.994Z"
              //       fill="white"
              //     />
              //     <path
              //       d="M176.735 6.46204V14.535C176.239 13.8945 175.652 13.3822 174.969 13.0015C173.976 12.45 172.862 12.1743 171.63 12.1743C170.213 12.1743 168.949 12.4874 167.835 13.1118C166.721 13.738 165.843 14.6061 165.2 15.7198C164.556 16.8334 164.234 18.1338 164.234 19.6246C164.234 21.1154 164.556 22.4211 165.2 23.5436C165.844 24.6662 166.723 25.5396 167.835 26.1658C168.949 26.792 170.212 27.1033 171.63 27.1033C172.9 27.1033 174.031 26.8223 175.024 26.2619C175.739 25.8581 176.344 25.3119 176.845 24.627V26.9379H179.384V6.46204H176.735ZM176.114 22.3428C175.682 23.1256 175.093 23.7269 174.348 24.1503C173.602 24.5737 172.77 24.7854 171.85 24.7854C170.913 24.7854 170.075 24.5737 169.338 24.1503C168.602 23.7269 168.013 23.1256 167.572 22.3428C167.131 21.5619 166.91 20.6546 166.91 19.6246C166.91 18.5768 167.131 17.6695 167.572 16.9063C168.013 16.1432 168.602 15.5508 169.338 15.1274C170.073 14.704 170.911 14.4923 171.85 14.4923C172.77 14.4923 173.602 14.704 174.348 15.1274C175.093 15.5508 175.682 16.1432 176.114 16.9063C176.547 17.6695 176.764 18.5768 176.764 19.6246C176.764 20.6546 176.547 21.5601 176.114 22.3428Z"
              //       fill="white"
              //     />
              //     <path
              //       d="M194.966 12.3108V14.5523C194.422 13.8567 193.76 13.3159 192.979 12.9316C191.949 12.4264 190.809 12.172 189.556 12.172C188.14 12.172 186.876 12.4673 185.762 13.0544C184.648 13.6432 183.766 14.4669 183.113 15.5236C182.46 16.582 182.133 17.8184 182.133 19.2345C182.133 20.6327 182.458 21.8656 183.113 22.9329C183.766 24.0003 184.648 24.8329 185.762 25.4306C186.876 26.0283 188.139 26.3272 189.556 26.3272C190.807 26.3272 191.947 26.0657 192.979 25.5409C193.696 25.1762 194.312 24.6799 194.827 24.0608V25.2243C194.827 26.8805 194.422 28.1115 193.612 28.9227C192.803 29.7321 191.533 30.136 189.804 30.136C188.719 30.136 187.68 29.9652 186.685 29.6254C185.693 29.2856 184.855 28.8195 184.173 28.2325L182.903 30.2747C183.695 30.9739 184.719 31.5111 185.981 31.8882C187.24 32.2654 188.542 32.454 189.886 32.454C192.369 32.454 194.255 31.8473 195.543 30.6323C196.831 29.4173 197.475 27.5227 197.475 24.9467V12.3072H194.966V12.3108ZM194.235 21.7215C193.803 22.4384 193.209 23.0005 192.454 23.4044C191.7 23.81 190.836 24.011 189.861 24.011C188.886 24.011 188.016 23.8082 187.253 23.4044C186.49 23.0005 185.892 22.4384 185.459 21.7215C185.027 21.0045 184.81 20.1756 184.81 19.238C184.81 18.3005 185.025 17.4715 185.459 16.7546C185.892 16.0377 186.49 15.4809 187.253 15.0842C188.016 14.6892 188.886 14.49 189.861 14.49C190.836 14.49 191.7 14.6875 192.454 15.0842C193.209 15.4791 193.801 16.0359 194.235 16.7546C194.667 17.4715 194.884 18.3005 194.884 19.238C194.884 20.1756 194.667 21.0045 194.235 21.7215Z"
              //       fill="white"
              //     />
              //     <path
              //       d="M214.076 15.7471C213.459 14.6157 212.608 13.7369 211.523 13.1124C210.438 12.488 209.188 12.1749 207.77 12.1749C206.371 12.1749 205.115 12.4916 204.004 13.1267C202.89 13.7618 202.017 14.6406 201.381 15.7613C200.746 16.8838 200.43 18.1718 200.43 19.6252C200.43 21.0786 200.755 22.3666 201.41 23.4891C202.063 24.6117 202.983 25.494 204.169 26.138C205.356 26.782 206.731 27.104 208.295 27.104C209.508 27.104 210.607 26.9012 211.593 26.4974C212.576 26.0935 213.4 25.5047 214.062 24.7309L212.6 23.0195C212.066 23.6083 211.445 24.0495 210.737 24.3448C210.029 24.6383 209.243 24.786 208.378 24.786C207.33 24.786 206.4 24.5743 205.59 24.1509C204.781 23.7275 204.151 23.1351 203.699 22.3719C203.367 21.8098 203.159 21.1872 203.071 20.5094H214.946C214.964 20.3813 214.978 20.2425 214.987 20.0949C214.996 19.9472 215.001 19.8191 215.001 19.7088C215.001 18.2003 214.693 16.8785 214.076 15.7471ZM205.315 15.0302C206.032 14.6157 206.85 14.4093 207.771 14.4093C208.709 14.4093 209.533 14.6157 210.241 15.0302C210.949 15.4447 211.506 16.0193 211.909 16.7558C212.215 17.3144 212.4 17.9299 212.464 18.6041H203.064C203.141 17.9334 203.329 17.3215 203.63 16.7682C204.036 16.0246 204.598 15.4447 205.315 15.0302Z"
              //       fill="white"
              //     />
              //      <path
              //       d="M214.849 8.024V3.194H213.001V2.13H217.999V3.194H216.137V8.024H214.849ZM218.853 8.024V2.13H219.875L221.891 5.672L223.907 2.13H224.915V8.024H223.795V4.328L222.213 7.1H221.569L219.973 4.342V8.024H218.853Z"
              //       fill="white"
              //     />
              //     <path
              //       d="M214.849 8.024V3.194H213.001V2.13H217.999V3.194H216.137V8.024H214.849ZM218.853 8.024V2.13H219.875L221.891 5.672L223.907 2.13H224.915V8.024H223.795V4.328L222.213 7.1H221.569L219.973 4.342V8.024H218.853Z"
              //       fill="white"
              //     />
              //     <defs>
              //       <linearGradient
              //         id="paint0_linear_1_1666"
              //         x1="4.87222"
              //         y1="38.5071"
              //         x2="33.212"
              //         y2="10.1629"
              //         gradientUnits="userSpaceOnUse"
              //       >
              //         <stop
              //           offset="0.06404"
              //           stop-color="white"
              //           stop-opacity="0"
              //         />
              //         <stop
              //           offset="0.10854"
              //           stop-color="white"
              //           stop-opacity="0.02531"
              //         />
              //         <stop
              //           offset="0.17062"
              //           stop-color="white"
              //           stop-opacity="0.09636"
              //         />
              //         <stop
              //           offset="0.24307"
              //           stop-color="white"
              //           stop-opacity="0.21315"
              //         />
              //         <stop
              //           offset="0.32336"
              //           stop-color="white"
              //           stop-opacity="0.37582"
              //         />
              //         <stop
              //           offset="0.41014"
              //           stop-color="white"
              //           stop-opacity="0.5846"
              //         />
              //         <stop
              //           offset="0.50094"
              //           stop-color="white"
              //           stop-opacity="0.83509"
              //         />
              //         <stop
              //           offset="0.54585"
              //           stop-color="white"
              //           stop-opacity="0.97"
              //         />
              //         <stop offset="1" stop-color="white" />
              //       </linearGradient>
              //     </defs>
              //   </svg>
              // </Link>
              // <></>
            ) : (
              <Link className="cursor-pointer" to="/">
                <svg
                  width="215"
                  height="28"
                  viewBox="0 0 309 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M36.4812 17.4737L24.9961 1.06907C24.0012 -0.356356 21.9007 -0.356356 20.9057 1.06907L0.441442 30.2902C-0.332418 31.3962 -0.0621819 32.9076 1.04333 33.6818C2.14884 34.4559 3.65971 34.1856 4.43357 33.0796L22.9448 6.6233L32.5505 20.3491C32.6242 20.4597 32.6733 20.5212 32.6733 20.5335C32.9927 20.9881 33.1523 21.5411 33.1032 22.1432C33.0049 23.3474 31.9977 24.3059 30.7939 24.3674C29.8972 24.4165 29.1111 23.9741 28.6566 23.2983C28.632 23.2614 28.4478 23.0034 28.4478 23.0034L24.9593 18.0144C24.5171 17.3754 23.7923 16.9699 22.9571 16.9699C21.6059 16.9699 20.5249 18.0635 20.5249 19.403C20.5249 19.9068 20.6723 20.3737 20.9426 20.7669L24.6767 26.0877C25.5366 27.3288 26.7772 28.3118 28.2512 28.8402C29.0497 29.1229 29.9095 29.2703 30.8062 29.258C34.7001 29.1966 37.8324 26.1123 38.0043 22.2784C38.078 20.4597 37.5007 18.7885 36.4812 17.4737Z"
                    fill="url(#paint0_linear_1_5286)"
                  />
                  <path
                    d="M22.9503 16.9526C24.2939 16.9526 25.3836 18.044 25.3888 19.3912C25.3923 20.7366 24.2974 21.8297 22.9503 21.8297C21.6031 21.8297 20.5117 20.7383 20.5117 19.3912C20.5117 18.0423 21.6031 16.9526 22.9503 16.9526Z"
                    fill="#0B9CE9"
                  />
                  <path
                    d="M63.0269 25.999H65.9303L57.5422 7.53455C57.1989 6.77847 56.4445 6.29102 55.612 6.29102C54.7794 6.29102 54.0251 6.77847 53.6817 7.53633L45.3203 25.999H48.1685L50.4617 20.7794H60.732L63.0269 25.999ZM51.433 18.5716L55.5977 9.09298L59.7624 18.5716H51.433Z"
                    fill="#001997"
                  />
                  <path
                    d="M79.2512 5.52246V13.5957C78.7548 12.9552 78.1678 12.4429 77.4846 12.0622C76.4919 11.5107 75.3783 11.2349 74.1454 11.2349C72.7293 11.2349 71.4644 11.548 70.3507 12.1725C69.2371 12.7987 68.3582 13.6668 67.716 14.7805C67.072 15.8942 66.75 17.1946 66.75 18.6855C66.75 20.1763 67.072 21.4821 67.716 22.6046C68.36 23.7272 69.2389 24.6007 70.3507 25.2269C71.4644 25.8531 72.7275 26.1645 74.1454 26.1645C75.4156 26.1645 76.5471 25.8834 77.5398 25.323C78.2549 24.9192 78.8598 24.373 79.3615 23.6881V25.999H81.9002V5.52246H79.2512ZM78.6303 21.4038C78.198 22.1866 77.6092 22.7879 76.8638 23.2113C76.1183 23.6347 75.2857 23.8464 74.366 23.8464C73.4284 23.8464 72.5905 23.6347 71.854 23.2113C71.1175 22.7879 70.5286 22.1866 70.0875 21.4038C69.6463 20.6228 69.4257 19.7155 69.4257 18.6855C69.4257 17.6376 69.6463 16.7303 70.0875 15.9671C70.5286 15.2039 71.1175 14.6115 71.854 14.1881C72.5888 13.7647 73.4267 13.553 74.366 13.553C75.2857 13.553 76.1183 13.7647 76.8638 14.1881C77.6092 14.6115 78.198 15.2039 78.6303 15.9671C79.0626 16.7303 79.2797 17.6376 79.2797 18.6855C79.2779 19.7155 79.0608 20.621 78.6303 21.4038Z"
                    fill="#001997"
                  />
                  <path
                    d="M113.224 11.3717V13.5937C112.728 12.9532 112.14 12.4409 111.457 12.0602C110.465 11.5087 109.351 11.2329 108.118 11.2329C106.702 11.2329 105.437 11.546 104.323 12.1705C103.21 12.7967 102.331 13.6648 101.689 14.7785C101.045 15.8922 100.723 17.1926 100.723 18.6835C100.723 20.1743 101.045 21.4801 101.689 22.6027C102.333 23.7252 103.212 24.5987 104.323 25.2249C105.437 25.8511 106.7 26.1625 108.118 26.1625C109.388 26.1625 110.52 25.8814 111.512 25.321C112.228 24.9172 112.832 24.371 113.334 23.6861V25.997H115.873V11.3717H113.224ZM112.603 21.4036C112.171 22.1864 111.582 22.7877 110.836 23.2111C110.091 23.6345 109.258 23.8462 108.339 23.8462C107.401 23.8462 106.563 23.6345 105.827 23.2111C105.09 22.7877 104.501 22.1864 104.06 21.4036C103.619 20.6226 103.398 19.7153 103.398 18.6852C103.398 17.6374 103.619 16.7301 104.06 15.9669C104.501 15.2037 105.09 14.6113 105.827 14.1879C106.561 13.7645 107.399 13.5528 108.339 13.5528C109.258 13.5528 110.091 13.7645 110.836 14.1879C111.582 14.6113 112.171 15.2037 112.603 15.9669C113.035 16.7301 113.252 17.6374 113.252 18.6852C113.251 19.7153 113.033 20.6208 112.603 21.4036Z"
                    fill="#001997"
                  />
                  <path
                    d="M97.3407 11.3721L92.1406 23.2595L87.0384 11.3721H84.2773L90.2122 24.9282C90.5413 25.6808 91.2849 26.1664 92.1068 26.1664C92.9287 26.1664 93.6724 25.6808 94.0015 24.9282L99.9363 11.3721H97.3407Z"
                    fill="#001997"
                  />
                  <path
                    d="M132.651 14.0206C132.135 13.0831 131.423 12.3839 130.512 11.9232C129.602 11.4642 128.548 11.2329 127.353 11.2329C126.028 11.2329 124.869 11.4998 123.875 12.0335C123.133 12.432 122.535 12.9479 122.082 13.583V11.3717H119.543V25.997H122.192V18.4629C122.192 17.3954 122.381 16.5042 122.758 15.7854C123.135 15.0685 123.672 14.5259 124.371 14.1576C125.07 13.7894 125.889 13.6061 126.828 13.6061C128.079 13.6061 129.05 13.9655 129.739 14.6824C130.429 15.3994 130.774 16.4668 130.774 17.8829V25.997H133.423V17.5805C133.423 16.1466 133.165 14.96 132.651 14.0206Z"
                    fill="#001997"
                  />
                  <path
                    d="M144.688 23.2382C144.137 23.699 143.446 23.9285 142.619 23.9285C141.883 23.9285 141.317 23.7168 140.922 23.2933C140.525 22.8699 140.328 22.2633 140.328 21.4716V13.5514H144.523V11.3721H140.328V7.4458H137.679V11.3721H135.195V13.5514H137.679V21.5819C137.679 23.0532 138.083 24.1846 138.894 24.9763C139.703 25.768 140.844 26.1629 142.315 26.1629C142.922 26.1629 143.507 26.0793 144.067 25.9138C144.628 25.7484 145.112 25.4904 145.515 25.1418L144.688 23.2382Z"
                    fill="#001997"
                  />
                  <path
                    d="M150.994 23.5974V17.3601H160.68V15.0154H150.994V9.08235H161.867V6.68066H148.234V25.9991H162.253V23.5974H150.994Z"
                    fill="#001997"
                  />
                  <path
                    d="M176.728 5.52246V13.5957C176.231 12.9552 175.644 12.4429 174.961 12.0622C173.969 11.5107 172.855 11.2349 171.622 11.2349C170.206 11.2349 168.941 11.548 167.827 12.1725C166.714 12.7987 165.835 13.6668 165.193 14.7805C164.549 15.8942 164.227 17.1946 164.227 18.6855C164.227 20.1763 164.549 21.4821 165.193 22.6046C165.837 23.7272 166.715 24.6007 167.827 25.2269C168.941 25.8531 170.204 26.1645 171.622 26.1645C172.892 26.1645 174.024 25.8834 175.016 25.323C175.732 24.9192 176.336 24.373 176.838 23.6881V25.999H179.377V5.52246H176.728ZM176.107 21.4038C175.675 22.1866 175.086 22.7879 174.34 23.2113C173.595 23.6347 172.762 23.8464 171.843 23.8464C170.905 23.8464 170.067 23.6347 169.331 23.2113C168.594 22.7879 168.005 22.1866 167.564 21.4038C167.123 20.6228 166.902 19.7155 166.902 18.6855C166.902 17.6376 167.123 16.7303 167.564 15.9671C168.005 15.2039 168.594 14.6115 169.331 14.1881C170.065 13.7647 170.903 13.553 171.843 13.553C172.762 13.553 173.595 13.7647 174.34 14.1881C175.086 14.6115 175.675 15.2039 176.107 15.9671C176.539 16.7303 176.756 17.6376 176.756 18.6855C176.756 19.7155 176.539 20.621 176.107 21.4038Z"
                    fill="#001997"
                  />
                  <path
                    d="M194.963 11.3717V13.6132C194.418 12.9176 193.757 12.3768 192.976 11.9926C191.946 11.4873 190.805 11.2329 189.553 11.2329C188.137 11.2329 186.872 11.5282 185.758 12.1153C184.644 12.7042 183.762 13.5278 183.109 14.5846C182.456 15.6431 182.129 16.8795 182.129 18.2956C182.129 19.6939 182.454 20.9268 183.109 21.9942C183.762 23.0616 184.644 23.8942 185.758 24.492C186.872 25.0897 188.135 25.3886 189.553 25.3886C190.803 25.3886 191.944 25.1271 192.976 24.6023C193.693 24.2376 194.308 23.7412 194.824 23.1221V24.2856C194.824 25.9419 194.418 27.173 193.609 27.9842C192.799 28.7937 191.529 29.1975 189.8 29.1975C188.715 29.1975 187.676 29.0267 186.681 28.6869C185.689 28.3471 184.851 27.881 184.169 27.2939L182.899 29.3363C183.691 30.0354 184.716 30.5727 185.977 30.9498C187.236 31.327 188.539 31.5156 189.882 31.5156C192.365 31.5156 194.251 30.9089 195.539 29.6938C196.827 28.4788 197.471 26.5841 197.471 24.0081V11.3681H194.963V11.3717ZM194.232 20.7827C193.799 21.4997 193.205 22.0618 192.451 22.4657C191.696 22.8713 190.832 23.0723 189.857 23.0723C188.882 23.0723 188.012 22.8695 187.249 22.4657C186.486 22.0618 185.888 21.4997 185.456 20.7827C185.023 20.0658 184.806 19.2367 184.806 18.2992C184.806 17.3616 185.022 16.5326 185.456 15.8157C185.888 15.0987 186.486 14.5419 187.249 14.1452C188.012 13.7502 188.882 13.551 189.857 13.551C190.832 13.551 191.696 13.7484 192.451 14.1452C193.205 14.5401 193.798 15.0969 194.232 15.8157C194.664 16.5326 194.881 17.3616 194.881 18.2992C194.881 19.2367 194.664 20.0658 194.232 20.7827Z"
                    fill="#001997"
                  />
                  <path
                    d="M214.077 14.8071C213.459 13.6757 212.609 12.7968 211.524 12.1724C210.438 11.548 209.188 11.2349 207.77 11.2349C206.372 11.2349 205.116 11.5515 204.004 12.1866C202.89 12.8218 202.017 13.7006 201.381 14.8214C200.746 15.9439 200.43 17.232 200.43 18.6854C200.43 20.1389 200.755 21.4269 201.41 22.5495C202.063 23.672 202.983 24.5544 204.169 25.1984C205.356 25.8424 206.731 26.1644 208.295 26.1644C209.508 26.1644 210.607 25.9616 211.593 25.5578C212.577 25.1539 213.401 24.5651 214.062 23.7912L212.6 22.0798C212.066 22.6686 211.445 23.1098 210.737 23.4052C210.029 23.6987 209.243 23.8464 208.378 23.8464C207.331 23.8464 206.4 23.6347 205.591 23.2113C204.781 22.7878 204.151 22.1954 203.7 21.4322C203.367 20.8701 203.159 20.2474 203.072 19.5696H214.947C214.964 19.4415 214.979 19.3027 214.987 19.1551C214.996 19.0074 215.002 18.8793 215.002 18.769C215.002 17.2604 214.694 15.9386 214.077 14.8071ZM205.315 14.0902C206.032 13.6757 206.85 13.4693 207.772 13.4693C208.709 13.4693 209.533 13.6757 210.241 14.0902C210.949 14.5047 211.506 15.0793 211.91 15.8158C212.216 16.3745 212.401 16.99 212.465 17.6643H203.064C203.141 16.9936 203.329 16.3816 203.63 15.8283C204.036 15.0847 204.598 14.5047 205.315 14.0902Z"
                    fill="#001997"
                  />
                  <path
                    d="M237.66 26.252C235.662 26.252 233.954 25.8413 232.536 25.02C231.117 24.1987 230.025 23.032 229.26 21.52C228.513 19.9893 228.14 18.188 228.14 16.116C228.14 14.044 228.513 12.252 229.26 10.74C230.025 9.228 231.117 8.06133 232.536 7.24C233.954 6.41867 235.662 6.008 237.66 6.008C239.004 6.008 240.254 6.22267 241.412 6.652C242.588 7.06267 243.568 7.66 244.352 8.444L243.344 10.768C242.485 10.0027 241.598 9.452 240.684 9.116C239.788 8.76133 238.808 8.584 237.744 8.584C235.616 8.584 233.992 9.23733 232.872 10.544C231.752 11.8507 231.192 13.708 231.192 16.116C231.192 18.524 231.752 20.3907 232.872 21.716C233.992 23.0227 235.616 23.676 237.744 23.676C238.808 23.676 239.788 23.508 240.684 23.172C241.598 22.8173 242.485 22.2573 243.344 21.492L244.352 23.816C243.568 24.5813 242.588 25.1787 241.412 25.608C240.254 26.0373 239.004 26.252 237.66 26.252ZM247.734 26V6.26H255.91C258.038 6.26 259.68 6.792 260.838 7.856C261.995 8.90133 262.574 10.376 262.574 12.28C262.574 14.2027 261.995 15.696 260.838 16.76C259.68 17.8053 258.038 18.328 255.91 18.328H250.646V26H247.734ZM250.646 16.004H255.49C258.327 16.004 259.746 14.7627 259.746 12.28C259.746 9.816 258.327 8.584 255.49 8.584H250.646V16.004ZM269.995 26V8.696H262.995V6.26H279.879V8.696H272.879V26H269.995Z"
                    fill="#001997"
                  />
                  <path
                    d="M214.849 8.024V3.194H213.001V2.13H217.999V3.194H216.137V8.024H214.849ZM218.853 8.024V2.13H219.875L221.891 5.672L223.907 2.13H224.915V8.024H223.795V4.328L222.213 7.1H221.569L219.973 4.342V8.024H218.853Z"
                    fill="#001997"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1_5286"
                      x1="4.87243"
                      y1="37.5677"
                      x2="33.2131"
                      y2="9.22231"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop
                        offset="0.06404"
                        stop-color="#001997"
                        stop-opacity="0"
                      />
                      <stop
                        offset="0.12664"
                        stop-color="#001997"
                        stop-opacity="0.04268"
                      />
                      <stop
                        offset="0.21397"
                        stop-color="#001997"
                        stop-opacity="0.16247"
                      />
                      <stop
                        offset="0.31582"
                        stop-color="#001997"
                        stop-opacity="0.35922"
                      />
                      <stop
                        offset="0.42866"
                        stop-color="#001997"
                        stop-opacity="0.63316"
                      />
                      <stop
                        offset="0.54585"
                        stop-color="#001997"
                        stop-opacity="0.97"
                      />
                      <stop offset="1" stop-color="#001997" />
                    </linearGradient>
                  </defs>
                </svg>
              </Link>
            )}

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="text-white bg-[#000833] flex items-center justify-center hover:text-gray-300 focus:outline-none cursor-pointer"
              >
                <MenuOutlined className="h-10 w-10" />
              </button>
            </div>

            {/* Desktop menu */}
            <div className="hidden md:flex space-x-4">
              <a
                href="/react-dashboard"
                className={`hover:underline ${initialColor === "#000833" ? "text-white" : "text-[#000833]"
                  }`}
              >
                Performance
              </a>
              {/* react-dashboard */}
               {/* <a
                href="/product-catalogue"
                className={`hover:underline ${
                  initialColor === "#000833"
                    ? "text-gray-300 hover:text-gray-300 "
                    : "text-[#000833]"
                }`}
              >
                AdvantEdge™ CPT
              </a>  */}
              <Dropdown
                overlay={menu}
                trigger={["click"]}
                overlayStyle={{ maxHeight: "80vh", overflowY: "auto" }}
              >
                <a
                  href="#"
                  className={`hover:underline ${initialColor === "#000833"
                      ? "text-gray-300 hover:text-gray-300"
                      : "text-[#000833]"
                    }`}
                >
                  Company <DownOutlined />
                </a>
              </Dropdown>
            </div>

            {/* User profile */}
            {/* <div style={{flexDirection:"row",display:'flex',gap:30,alignItems:"center"}} className="hidden md:flex items-center"> */}
            <div className="hidden md:flex items-center gap-30">
              <Dropdown overlay={userMenu} trigger={["click"]}>
                <div className="flex items-center cursor-pointer">
                  <Avatar
                    icon={<UserOutlined />}
                    className="bg-white text-blue-900"
                  />
                  <div
                    className={`ml-2 flex flex-col gap-1 ${initialColor === "#000833"
                        ? "text-white"
                        : "text-[#000833]"
                      }`}
                  >
                    <span>
                      {userDetailsState?.first_name}{" "}
                      {userDetailsState?.last_name}{" "}
                      <span className="text-xl font-bold"></span>{" "}
                      <DownOutlined className="ml-1" />
                    </span>
                    <span className="ml-1 -mt-1 text-gray-300 text-xs">
                      {userRoleOptions(userDetailsState?.user_roles_id)}
                    </span>
                  </div>
                </div>
              </Dropdown>
              {/* <div className="hidden md:flex items-center ml-6">
              <Button onClick={()=>setSupportVisible(true)}>Support</Button>
            </div> */}
              {/* </div> */}


            </div>

          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <a
                href="/#"
                className={`block px-3 py-2 rounded-md text-base font-medium ${initialColor === "#000833" ? "text-white" : "text-[#000833]"
                  } `}
              >
                Performance
              </a>
              {/* <a
                href="/product-catalogue"
                className={`block px-3 py-2 rounded-md text-base font-medium ${
                  initialColor === "#000833"
                    ? "text-gray-300 hover:text-gray-300 "
                    : "text-[#000833]"
                }`}
              >
                AdvantEdge™ CPT
              </a> */}
              <Dropdown overlay={menu} trigger={["click"]}>
                <a
                  href="#"
                  className={`block px-3 py-2 rounded-md text-base font-medium ${initialColor === "#000833"
                      ? "text-gray-300 hover:text-white"
                      : "text-[#000833]"
                    }  `}
                >
                  Company <DownOutlined />
                </a>
              </Dropdown>
            </div>
            <div style={{ flexDirection: "row", display: "flex", alignItems: "center", justifyContent: 'space-between' }} className="border-t border-indigo-800 pr-8">
              <div className="pt-4 pb-2 px-2">
                <Dropdown overlay={userMenu} trigger={["click"]}>
                  <div className="flex items-center px-5 cursor-pointer">
                    <Avatar
                      icon={<UserOutlined />}
                      className="bg-white text-blue-900"
                    />
                    <div className="ml-3">
                      <div
                        className={`text-base font-medium ${initialColor === "#000833"
                            ? "text-white"
                            : "text-[#000833]"
                          }`}
                      >
                        {userDetailsState?.first_name}{" "}
                        {userDetailsState?.last_name} . . <DownOutlined />
                      </div>
                      <span className="ml-1 -mt-1 text-gray-300 text-xs">
                        {userRoleOptions(userDetailsState?.user_roles_id)}
                      </span>
                      {/* <div className="text-sm font-medium text-gray-300">CEO</div> */}
                    </div>
                  </div>
                </Dropdown>
              </div>
              {/* <div >
              <Button onClick={()=>setSupportVisible(true)}>Support</Button>
            </div> */}
            </div>
          </div>
        )}
      </div>
      <Support
        visible={supportVisible}
        handleCancel={() => setSupportVisible(false)}
        handleSubmit={(values) => console.log('Form Values:', values)}
        loading={false}
      />
      <ChangePassword isVisible={PasswordModal} onClose={() => setPasswordModal(false)} />
    </>
  );
};

export default Header;
